import styled from "styled-components";
import React from "react";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";

const AddButtonTransp = ({ title, onClick }) => {
  return (
    <Button onClick={onClick}>
      <Box
        component={Icon}
        icon={"eva:plus-outline"}
        style={{ marginRight: "8px" }}
      />
      {title}
    </Button>
  );
};

const Button = styled.button`
  font-family: "Din";
  border-radius: 6px;
  background-color: #e0ebfe;
  border: 1.5px solid #e7e7e9;
  height: 38px;
  width: 100%;
  white-space: nowrap;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 11px;
  margin-top: 10px;
  font-size: 0.82rem;
  color: ${COLORS.primary};
  &:focus {
    outline-color: ${COLORS.primary};
  }
`;

const Title = styled.span`
  margin-right: 10px;
`;

export default AddButtonTransp;
